import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";

let registered = false;

/** Register the Chart.js pieces the head-office widgets use (idempotent). */
export function registerHeadOfficeCharts() {
  if (registered) return;
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    ArcElement,
    Tooltip,
    Filler,
    Legend,
  );
  registered = true;
}

/** Read a themed CSS variable off <html>, with a fallback. */
export function readThemeVar(name: string, fallback: string) {
  if (typeof window === "undefined") return fallback;
  const v = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  return v || fallback;
}

/** "#9A469B" -> "154,70,155" */
export function hexToRgb(hex: string) {
  const h = hex.replace("#", "");
  if (h.length < 6) return "154,70,155";
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `${r},${g},${b}`;
}
